// export const AUTH_LOGIN="auth/login"
// export const AUTH_LOGOUT="auth/logout"

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SIGN_UP = "SIGN_UP";